import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./_assets/css/plugins.bundle.css";
import "./_assets/css/prismjs.bundle.css";
import "./_assets/css/style.bundle.css";
import "./_assets/bootstrap/dist/css/bootstrap.min.css";
import "./_assets/css/style.css";
import "./_assets/font-awesome/css/font-awesome.min.css";


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
